module.exports = {
  RFID_FILE_DELETE_REQUEST: 'RFID_FILE_DELETE_REQUEST',
  RFID_FILE_DELETE_SUCCESS: 'RFID_FILE_DELETE_SUCCESS',
  RFID_FILE_DELETE_FAILURE: 'RFID_FILE_DELETE_FAILURE',
};
